<template>
  <div class="sj-table-filter">
    <SjInput
      class="sj-table-filter-input"
      size="small"
      @click.native="
        e => {
          e.stopPropagation();
        }
      "
      :placeholder="placeholder"
      @keyup.enter.native="check"
      ref="filter"
      :iconClickable="true"
      v-model="filter"
    >
    </SjInput>
    <div class="sj-table-filter-suffix">
      <i class="iconfont icon-icon_select" @click="check" />
      <i class="iconfont icon-icon_close" @click="clear" />
    </div>
  </div>
</template>

<script>
/**
 * table-filter
 * 用于表格表头处处理数据过滤
 */
export default {
  name: "table-filter",
  props: {
    defaultFilter: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: "过滤"
    }
  },
  data() {
    return {
      filter: this.defaultFilter
    };
  },
  methods: {
    clearFilter() {
      this.filter = null;
    },
    clear() {
      this.clearFilter();
      this.check();
      this.focus();
    },
    check() {
      this.$emit("filter", this.filter);
    },
    focus() {
      this.$nextTick(() => {
        this.$refs.filter.focus();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.sj-table-filter {
  position: relative;

  .sj-table-filter-input {
    padding-right: 50px !important;
  }
  .sj-table-filter-suffix {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    .iconfont {
      cursor: pointer;
      &.icon-icon_select {
        color: @color-alert-success;
        font-size: 12px;
        padding: 0 4px;
      }
      &.icon-icon_close {
        color: @color-alert-error;
        font-size: 12px;
        padding: 0 4px;
      }
    }
  }
}
</style>
